import { FC, PropsWithChildren } from 'react';

import { IonCol } from '@ionic/react';
import classNames from 'classnames';
import { useContextSelector } from 'use-context-selector';

import { GridRowContext } from '../Grid.context';

import { GridColSize } from './GridCol.types';

type GridColProps = PropsWithChildren<{
  lg?: GridColSize;
  md?: GridColSize;
  sm?: GridColSize;
  xs?: GridColSize;
  xl?: GridColSize;
}>;

export const GridCol: FC<GridColProps> = ({ children, lg, md, sm, xl, xs }) => {
  const spacing = useContextSelector(GridRowContext, ({ spacing }) => spacing);

  return (
    <IonCol
      sizeLg={lg}
      sizeMd={md}
      sizeSm={sm}
      sizeXl={xl}
      sizeXs={xs}
      className={classNames({
        // 'ion-no-padding': true,
      })}
      style={{ '--spacing': spacing / 2 }}
    >
      {children}
    </IonCol>
  );
};
